// Générateur d'ambiances (Web Audio) — nappes musicales + textures nature. 100% libre de droits.
let ctx = null, master = null, userVol = null, tonalFilter = null, tonalLfo = null, timer = null;
let disposers = [];
let noiseBuffer = null, pinkBuffer = null, brownBuffer = null;
let pendingVolume = parseFloat(localStorage.getItem("coccon_ambient_vol") || "0.7");

const TONAL = {
  cocon:         { root: 130.81, type: "sine",     chords: [[0, 7, 10], [-2, 3, 7], [0, 5, 7]], scale: [0, 3, 5, 7, 10], interval: 5.5, cutoff: 900,  gain: 0.17 },
  constellation: { root: 196.00, type: "triangle", chords: [[0, 4, 7], [2, 5, 9], [-3, 0, 4]],  scale: [0, 2, 4, 7, 9],  interval: 5.0, cutoff: 1500, gain: 0.13, twinkle: true },
  derive:        { root: 146.83, type: "sine",     chords: [[0, 3, 7], [-2, 2, 5], [0, 5, 9]],  scale: [0, 2, 3, 7, 9],  interval: 6.5, cutoff: 1100, gain: 0.16 },
  etoiles:       { root: 174.61, type: "sine",     chords: [[0, 7], [4, 11], [2, 9]],           scale: [0, 2, 4, 7, 11], interval: 4.5, cutoff: 2000, gain: 0.12, twinkle: true },
};

const noteFreq = (root, semi) => root * Math.pow(2, semi / 12);

function ensureCtx() {
  if (ctx) return;
  const AC = window.AudioContext || window.webkitAudioContext;
  ctx = new AC();
  master = ctx.createGain(); master.gain.value = 0;
  userVol = ctx.createGain(); userVol.gain.value = pendingVolume;
  master.connect(userVol); userVol.connect(ctx.destination);
  tonalFilter = ctx.createBiquadFilter(); tonalFilter.type = "lowpass"; tonalFilter.frequency.value = 1200;
  const delay = ctx.createDelay(1.0); delay.delayTime.value = 0.45;
  const fb = ctx.createGain(); fb.gain.value = 0.34;
  const wet = ctx.createGain(); wet.gain.value = 0.5;
  tonalFilter.connect(master);
  tonalFilter.connect(delay); delay.connect(fb); fb.connect(delay); delay.connect(wet); wet.connect(master);
  tonalLfo = ctx.createOscillator(); const lg = ctx.createGain();
  tonalLfo.frequency.value = 0.05; lg.gain.value = 350; tonalLfo.connect(lg); lg.connect(tonalFilter.frequency); tonalLfo.start();
  const len = Math.floor(ctx.sampleRate * 2);
  noiseBuffer = ctx.createBuffer(1, len, ctx.sampleRate);
  const d = noiseBuffer.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  // Bruit rose (Paul Kellet)
  pinkBuffer = ctx.createBuffer(1, len, ctx.sampleRate);
  const pd = pinkBuffer.getChannelData(0);
  let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0;
  for (let i = 0; i < len; i++) {
    const w = Math.random() * 2 - 1;
    b0 = 0.99886 * b0 + w * 0.0555179; b1 = 0.99332 * b1 + w * 0.0750759; b2 = 0.96900 * b2 + w * 0.1538520;
    b3 = 0.86650 * b3 + w * 0.3104856; b4 = 0.55000 * b4 + w * 0.5329522; b5 = -0.7616 * b5 - w * 0.0168980;
    pd[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362) * 0.11; b6 = w * 0.115926;
  }
  // Bruit brun (intégration)
  brownBuffer = ctx.createBuffer(1, len, ctx.sampleRate);
  const bd = brownBuffer.getChannelData(0);
  let last = 0;
  for (let i = 0; i < len; i++) { const w = Math.random() * 2 - 1; last = (last + 0.02 * w) / 1.02; bd[i] = last * 3.5; }
}

const noiseSource = () => { const s = ctx.createBufferSource(); s.buffer = noiseBuffer; s.loop = true; return s; };

function registerVoice(out, sources, intervals = []) {
  disposers.push((now) => {
    intervals.forEach(clearInterval);
    out.gain.cancelScheduledValues(now);
    out.gain.setValueAtTime(out.gain.value, now);
    out.gain.linearRampToValueAtTime(0.0001, now + 0.4);
    setTimeout(() => { sources.forEach((s) => { try { s.stop(); } catch (e) {} }); try { out.disconnect(); } catch (e) {} }, 520);
  });
}

function teardown() {
  if (timer) { clearInterval(timer); timer = null; }
  const now = ctx ? ctx.currentTime : 0;
  disposers.forEach((fn) => fn(now));
  disposers = [];
}

// ---- Tonal ----
function playChord(mood) {
  const now = ctx.currentTime;
  const chord = mood.chords[Math.floor(Math.random() * mood.chords.length)];
  const dur = mood.interval * 1.6;
  chord.forEach((semi) => {
    const osc = ctx.createOscillator(); osc.type = mood.type;
    osc.frequency.value = noteFreq(mood.root, semi);
    const g = ctx.createGain(); g.gain.value = 0.0001;
    osc.connect(g); g.connect(tonalFilter);
    g.gain.setValueAtTime(0.0001, now);
    g.gain.linearRampToValueAtTime(0.18, now + 2.2);
    g.gain.linearRampToValueAtTime(0.0001, now + dur);
    osc.start(now); osc.stop(now + dur + 0.2);
  });
  if (mood.twinkle && Math.random() < 0.6) {
    const semi = mood.scale[Math.floor(Math.random() * mood.scale.length)] + 24;
    const osc = ctx.createOscillator(); osc.type = "sine";
    osc.frequency.value = noteFreq(mood.root, semi);
    const g = ctx.createGain(); g.gain.value = 0.0001;
    osc.connect(g); g.connect(tonalFilter);
    const t = now + Math.random() * mood.interval;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.linearRampToValueAtTime(0.09, t + 0.05);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 2.5);
    osc.start(t); osc.stop(t + 2.6);
  }
}

function startTonal(mood) {
  tonalFilter.frequency.setValueAtTime(mood.cutoff, ctx.currentTime);
  playChord(mood);
  timer = setInterval(() => playChord(mood), mood.interval * 1000);
}

// ---- Nature textures ----
function fadeInOut(out) { out.gain.setValueAtTime(0.0001, ctx.currentTime); out.gain.linearRampToValueAtTime(1, ctx.currentTime + 1.6); }

function startWaves() {
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  const src = noiseSource();
  const lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 550; lp.Q.value = 0.7;
  const g = ctx.createGain(); g.gain.value = 0.12;
  src.connect(lp); lp.connect(g); g.connect(out);
  const lfo = ctx.createOscillator(); lfo.frequency.value = 0.11; const lfoG = ctx.createGain(); lfoG.gain.value = 0.10;
  lfo.connect(lfoG); lfoG.connect(g.gain);
  const lfo2 = ctx.createOscillator(); lfo2.frequency.value = 0.07; const lfo2G = ctx.createGain(); lfo2G.gain.value = 220;
  lfo2.connect(lfo2G); lfo2G.connect(lp.frequency);
  src.start(); lfo.start(); lfo2.start();
  registerVoice(out, [src, lfo, lfo2]);
}

function startWind() {
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  const src = noiseSource();
  const bp = ctx.createBiquadFilter(); bp.type = "bandpass"; bp.frequency.value = 520; bp.Q.value = 1.4;
  const g = ctx.createGain(); g.gain.value = 0.16;
  src.connect(bp); bp.connect(g); g.connect(out);
  const lfo = ctx.createOscillator(); lfo.frequency.value = 0.08; const lfoG = ctx.createGain(); lfoG.gain.value = 0.11;
  lfo.connect(lfoG); lfoG.connect(g.gain);
  const lfo2 = ctx.createOscillator(); lfo2.frequency.value = 0.05; const lfo2G = ctx.createGain(); lfo2G.gain.value = 380;
  lfo2.connect(lfo2G); lfo2G.connect(bp.frequency);
  src.start(); lfo.start(); lfo2.start();
  registerVoice(out, [src, lfo, lfo2]);
}

function startRain() {
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  const src = noiseSource();
  const hp = ctx.createBiquadFilter(); hp.type = "highpass"; hp.frequency.value = 1400;
  const g = ctx.createGain(); g.gain.value = 0.10;
  src.connect(hp); hp.connect(g); g.connect(out);
  src.start();
  const drop = setInterval(() => {
    if (Math.random() > 0.7) return;
    const now = ctx.currentTime;
    const o = ctx.createOscillator(); o.type = "sine"; o.frequency.value = 900 + Math.random() * 1400;
    const dg = ctx.createGain(); dg.gain.value = 0.0001;
    o.connect(dg); dg.connect(out);
    dg.gain.setValueAtTime(0.0001, now);
    dg.gain.linearRampToValueAtTime(0.05, now + 0.01);
    dg.gain.exponentialRampToValueAtTime(0.0001, now + 0.18);
    o.start(now); o.stop(now + 0.2);
  }, 320);
  registerVoice(out, [src], [drop]);
}

function startForest() {
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  const src = noiseSource();
  const lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 700; lp.Q.value = 0.6;
  const g = ctx.createGain(); g.gain.value = 0.06;
  src.connect(lp); lp.connect(g); g.connect(out);
  const lfo = ctx.createOscillator(); lfo.frequency.value = 0.06; const lfoG = ctx.createGain(); lfoG.gain.value = 0.03;
  lfo.connect(lfoG); lfoG.connect(g.gain);
  src.start(); lfo.start();
  const birds = setInterval(() => {
    if (Math.random() > 0.55) return;
    const now = ctx.currentTime;
    const base = 2200 + Math.random() * 1600;
    const notes = 2 + Math.floor(Math.random() * 3);
    for (let n = 0; n < notes; n++) {
      const t = now + n * 0.12;
      const o = ctx.createOscillator(); o.type = "sine";
      o.frequency.setValueAtTime(base * (1 + n * 0.05), t);
      o.frequency.linearRampToValueAtTime(base * (1 + n * 0.05) * 1.15, t + 0.06);
      const bg = ctx.createGain(); bg.gain.value = 0.0001;
      o.connect(bg); bg.connect(out);
      bg.gain.setValueAtTime(0.0001, t);
      bg.gain.linearRampToValueAtTime(0.06, t + 0.02);
      bg.gain.exponentialRampToValueAtTime(0.0001, t + 0.14);
      o.start(t); o.stop(t + 0.16);
    }
  }, 2600);
  registerVoice(out, [src, lfo], [birds]);
}

function startFire() {
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  // Lit de flammes bas (grondement chaud)
  const src = noiseSource();
  const lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 420; lp.Q.value = 0.5;
  const bed = ctx.createGain(); bed.gain.value = 0.05;
  src.connect(lp); lp.connect(bed); bed.connect(out);
  const flick = ctx.createOscillator(); flick.frequency.value = 0.4; const flickG = ctx.createGain(); flickG.gain.value = 0.02;
  flick.connect(flickG); flickG.connect(bed.gain);
  src.start(); flick.start();

  const pop = (cLo, cHi, gLo, gHi, dLo, dHi) => {
    const now = ctx.currentTime;
    const cs = noiseSource();
    const bp = ctx.createBiquadFilter(); bp.type = "bandpass";
    bp.frequency.value = cLo + Math.random() * (cHi - cLo); bp.Q.value = 1.1 + Math.random();
    const cg = ctx.createGain(); cg.gain.value = 0.0001;
    cs.connect(bp); bp.connect(cg); cg.connect(out);
    const peak = gLo + Math.random() * (gHi - gLo);
    const dec = dLo + Math.random() * (dHi - dLo);
    cg.gain.setValueAtTime(0.0001, now);
    cg.gain.linearRampToValueAtTime(peak, now + 0.0015);
    cg.gain.exponentialRampToValueAtTime(0.0001, now + dec);
    cs.start(now); cs.stop(now + dec + 0.05);
  };

  const tick = setInterval(() => {
    const r = Math.random();
    if (r < 0.34) pop(1900, 4400, 0.05, 0.12, 0.010, 0.028);       // petits crépitements secs
    else if (r < 0.41) pop(550, 1300, 0.11, 0.22, 0.03, 0.07);     // craquements plus graves
    else if (r < 0.45) {                                           // salve (rafale de pétillements)
      const n = 2 + Math.floor(Math.random() * 3);
      for (let i = 0; i < n; i++) setTimeout(() => pop(1600, 4000, 0.05, 0.11, 0.008, 0.022), i * (18 + Math.random() * 34));
    }
  }, 65);

  registerVoice(out, [src, flick], [tick]);
}

const NATURE = {
  vagues: { start: startWaves, master: 0.9 },
  vent:   { start: startWind,  master: 0.9 },
  pluie:  { start: startRain,  master: 0.95 },
  foret:  { start: startForest, master: 0.95 },
  feu:    { start: startFire,  master: 0.95 },
};

// ---- Battements binauraux (casque) ----
const BINAURAL = {
  delta: { carrier: 180, beat: 2 },
  theta: { carrier: 200, beat: 5 },
  alpha: { carrier: 210, beat: 10 },
  beta:  { carrier: 220, beat: 16 },
};

function startBinaural(key) {
  const p = BINAURAL[key];
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  const oscL = ctx.createOscillator(); oscL.type = "sine"; oscL.frequency.value = p.carrier;
  const oscR = ctx.createOscillator(); oscR.type = "sine"; oscR.frequency.value = p.carrier + p.beat;
  const panL = ctx.createStereoPanner(); panL.pan.value = -1;
  const panR = ctx.createStereoPanner(); panR.pan.value = 1;
  const g = ctx.createGain(); g.gain.value = 0.13;
  oscL.connect(panL); panL.connect(g);
  oscR.connect(panR); panR.connect(g);
  g.connect(out);
  oscL.start(); oscR.start();
  registerVoice(out, [oscL, oscR]);
}

// ---- Bruits de fond ----
function startNoise(kind) {
  const out = ctx.createGain(); out.connect(master); fadeInOut(out);
  const src = ctx.createBufferSource(); src.buffer = kind === "brun" ? brownBuffer : pinkBuffer; src.loop = true;
  const g = ctx.createGain(); g.gain.value = kind === "brun" ? 0.14 : 0.09;
  src.connect(g); g.connect(out);
  src.start();
  registerVoice(out, [src]);
}

export function startAmbient(key) {
  ensureCtx();
  if (ctx.state === "suspended") ctx.resume();
  teardown();
  if (TONAL[key]) {
    master.gain.cancelScheduledValues(ctx.currentTime);
    master.gain.linearRampToValueAtTime(TONAL[key].gain, ctx.currentTime + 2);
    startTonal(TONAL[key]);
  } else if (NATURE[key]) {
    master.gain.cancelScheduledValues(ctx.currentTime);
    master.gain.linearRampToValueAtTime(NATURE[key].master, ctx.currentTime + 2);
    NATURE[key].start();
  } else if (BINAURAL[key]) {
    master.gain.cancelScheduledValues(ctx.currentTime);
    master.gain.linearRampToValueAtTime(0.9, ctx.currentTime + 2);
    startBinaural(key);
  } else if (key === "rose" || key === "brun") {
    master.gain.cancelScheduledValues(ctx.currentTime);
    master.gain.linearRampToValueAtTime(0.9, ctx.currentTime + 2);
    startNoise(key);
  }
}

export function setVolume(v) {
  pendingVolume = v;
  localStorage.setItem("coccon_ambient_vol", String(v));
  if (userVol && ctx) userVol.gain.setTargetAtTime(v, ctx.currentTime, 0.05);
}

export function getVolume() { return pendingVolume; }

export function stopAmbient() {
  if (!ctx || !master) return;
  master.gain.cancelScheduledValues(ctx.currentTime);
  master.gain.linearRampToValueAtTime(0.0001, ctx.currentTime + 1.5);
  teardown();
}

export const TONAL_KEYS = ["cocon", "constellation", "derive", "etoiles"];
export const NATURE_KEYS = ["vagues", "vent", "pluie", "foret", "feu"];
export const BINAURAL_KEYS = ["delta", "theta", "alpha", "beta"];
export const NOISE_KEYS = ["rose", "brun"];
export const MOOD_KEYS = [...TONAL_KEYS, ...NATURE_KEYS, ...BINAURAL_KEYS, ...NOISE_KEYS];
